import { Inbox, ListOrdered, Users } from 'lucide-react';
import type { TriageView } from '../../hooks/useTriageView';
import { Tabs, TabsList, TabsTrigger } from '../../ui/tabs';

interface TriageViewSwitcherProps {
  value: TriageView;
  onChange: (view: TriageView) => void;
}

export function TriageViewSwitcher({ value, onChange }: TriageViewSwitcherProps) {
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as TriageView)}>
      <TabsList>
        <TabsTrigger value="priority" className="gap-1.5">
          <ListOrdered className="h-3.5 w-3.5" />
          Priority List
        </TabsTrigger>
        <TabsTrigger value="inbox" className="gap-1.5">
          <Inbox className="h-3.5 w-3.5" />
          By Inbox
        </TabsTrigger>
        <TabsTrigger value="customer" className="gap-1.5">
          <Users className="h-3.5 w-3.5" />
          By Customer
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
